<template>
    <v-textarea v-model="model"
                :label="valueItem.label"
                :error-messages="validationErrors"
                @input="emitInputEvent"
                stack-label outlined dense class="mr-4"></v-textarea>

</template>
<script>
    export default {
        props: {
            valueItem: {
                type: Object,
                default: function () {
                    return {
                        label: "",
                        isRequired: false,
                        requiredError: "",
                        error: "",
                        hasError: false,
                        value: 0,
                        textLengthError: "",
                        textLength: 0,
                    };
                },
            },
        },
        computed: {
            model: {
                get() {
                    return this.valueItem.value;
                },
                set(value) {
                    this.valueItem.value = value;
                }
            },
            validationErrors() {
                const errors = [];
                this.checkForErrors(this.valueItem);

                if (this.valueItem.hasError) errors.push(this.valueItem.error);
                return errors;
            },
        },
        methods: {
            checkForErrors: (vi) => {
                if (vi.isRequired && (vi.value == null || vi.value == "")) {
                    vi.hasError = true;
                    vi.error = vi.requiredError;
                    return;
                }

                if (!(vi.value == null || vi.value == "")) {
                    if (vi.textLength > 0 && vi.value.length > vi.textLength) {
                        vi.hasError = true;
                        vi.error = vi.textLengthError;
                        return;
                    }
                }

                vi.hasError = false;
                vi.error = "";
            },
            emitInputEvent: function () {
                this.$emit('input');
            }
        }
    }
</script>